<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body="true")
        el-form(:model="ruleForm",:inline="false", :rules="rules", ref="ruleForm" label-width="120px")
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 培训设置
                div.labelStyle
                    el-form-item(label="培训ID:" prop="trainCode")
                        font {{ruleForm.trainCode}}
                    el-form-item(label="培训名称:" prop="matchName")
                        font {{ruleForm.name}}
                    el-form-item(label="主办方:" prop="orgName")
                        font {{ruleForm.orgName}}
                    el-form-item(label="主办城市:" prop="cityName")
                        font {{ruleForm.provinceName}}&nbsp;{{ruleForm.cityName}}
                    div(v-if="pxtype == 5")
                        el-form-item(label="联系电话:" prop="")
                            font {{ruleForm.byx3}}
                    div(v-if="pxtype != 5")
                        el-form-item(label="培训场地:" prop="placeName")
                            font {{ruleForm.placesName}}
                        el-form-item(label="班级人数:" prop="classCount")
                            font {{ruleForm.classCount}}
                        el-form-item(label="级别" prop="level")
                            font {{ruleForm.level}}
                        el-form-item(label="是否替补:" prop="bench")
                            font(v-if="ruleForm.bench === 1") 是
                            font(v-if="ruleForm.bench === 0") 否
                        el-form-item(label="是否推荐首页:" prop="recommend")
                            font(v-if="ruleForm.recommend === 1") 是
                            font(v-if="ruleForm.recommend === 0") 否
                        el-form-item(label="报名时间:" prop="applyDate")
                            font {{ruleForm.applyStrTime}}&nbsp;至&nbsp;{{ruleForm.applyEndTime}}
                    el-form-item(label="列表页图:" prop="imgList")
                        <img :src="listImageUrl" :onerror="defaultImg" style="width:256px;height:190px;"/>
                    el-form-item(label="详情页图:" prop="imgDetailList")
                        <img :src="detailImageUrl" :onerror="defaultImg" style="width:750px;height:310px;"/>
                    el-form-item(label="培训简介:" prop="trainAbstract")
                        <div v-html="ruleForm.trainAbstract" ></div>
                    el-form-item(label="培训须知:" prop="trainNotice" v-if="pxtype != 5")
                        <div v-html="ruleForm.trainNotice" ></div>
            //-团体不显示
            div(v-if="pxtype != 5")
                br
                el-card(shadow="never")
                    div(slot="header")
                        font(style="font-weight: bold;font-size:18px;") 报名设置
                    div.labelStyle
                        el-form-item(label="年龄限定:")
                            font {{ruleForm.ageStr}}岁 - {{ruleForm.ageEnd}}岁
                        el-form-item(label="级别限定:" prop="scoreMin")
                            font {{ruleForm.levelStr}} - {{ruleForm.levelEnd}}
                        el-form-item(label="角色限定:" prop="repeatSign")
                            font {{ruleForm.roleLimit}}
                br
                el-card(shadow="never")
                    div(slot="header" )
                        font(style="font-weight: bold;font-size:18px;") 课程设置
                    div
                        el-table(:data="ruleForm.trainCourseList" border)
                            el-table-column(prop="code" label="课程编号" align='center' )
                            el-table-column(prop="trainTime" label="培训日期" align='center' )
                            el-table-column(prop="strTime" label="开始时间" align='center' )
                            el-table-column(prop="endTime" label="结束时间" align='center' )
                            el-table-column(prop="placeCode" label="场地编号" align='center' )
                br
                el-card(shadow="never")
                    div(slot="header" )
                        font(style="font-weight: bold;font-size:18px;") 教练设置
                    div
                        el-table(:data="ruleForm.trainCoachList" border)
                            el-table-column(prop="name" label="姓名" align='center' )
                            el-table-column(prop="sex" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font {{{0:'男',1:'女'}[scope.row.sex]}}
                            el-table-column(prop="coachLevel" label="级别" align='center' )
                            el-table-column(prop="phone" label="联系电话" align='center' )
                br
                el-card(shadow="never")
                    div(slot="header" )
                        font(style="font-weight: bold;font-size:18px;") 报名费用
                    div
                        el-table(:data="ruleForm.trainCostList" border)
                            el-table-column(prop="role" label="角色" align='center'  )
                            el-table-column(prop="cost" label="报名费用" align='center' )
                                template(slot-scope="scope")
                                    font ￥&nbsp;{{scope.row.cost}}元
                br
                el-card(shadow="never")
                    div(slot="header")
                        font(style="font-weight: bold;font-size:18px;") 退款设置
                    div
                        el-table(:data="ruleForm.trainRefundList" border)
                            el-table-column(prop="refundFee" label="距比赛开始时间/小时（含）" align='center')
                            el-table-column(prop="refundScale" label="退款比例/%" align='center')
                br
            el-card(shadow="never" v-if="type == 2")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 审核意见
                div
                    el-form-item(prop="verifyReason" label="填写审核意见:")
                        el-input(v-model="ruleForm.verifyReason" type="textarea" :rows=5 resize="none")
        //审核发布
        span.dialog-footer(slot="footer" )
            el-button(@click="releaseSubmit(3)" type="primary" v-if="type == 2") 发 布
            el-button(@click="releaseSubmit(2)" type="danger"  v-if="type == 2") 拒 绝
            el-button(@click="visible=false" v-if="type == 2") 取 消
            el-button(@click="visible=false" v-else) 返 回
        //- //支付弹窗组件
        zfpage(:openfree='visibleFee' :record='record' v-if="visibleFee" @zfsuccess="zfsuccess")
</template>
<script>
import zfpage from '@/pages/ct/competition/zfpage.vue'
import commonData from '../common.js'
export default {
	components: {
		zfpage
	},
	data () {
		return {
			visibleFee: false,
			record: {},
			pxLevel: commonData.pxLevel,
			pxState: commonData.pxState,
			roleType: commonData.roleType,
			pxtype: '',
			type: '',
			title: '查看详情',
			defaultImg: '',
			listImageUrl: '',
			detailImageUrl: '',
			tableData: [
				{
					dataName: '注册会员',
					type: 1,
					price: 0.0
				},
				{
					dataName: '初始会员',
					type: 2,
					price: 0.0
				},
				{
					dataName: '荣誉会员',
					type: 3,
					price: 0.0
				}
			],
			ruleForm: {
				id: null,
				name: '',
				orgId: '',
				provinceCode: '',
				provinceName: '',
				cityCode: '',
				cityName: '',
				placesId: '',
				classCount: '',
				level: '',
				bench: 1,
				applyStrTime: '',
				applyEndTime: '',
				tablePic: '',
				detailPic: '',
				trainAbstract: '',
				trainNotice: '',
				// 报名设置
				ageStr: 0,
				ageEnd: '',
				levelStr: 0,
				levelEnd: '',
				roleLimit: '',
				// 课程设置
				isShowCoach: '',
				trainCourseList: [], //课程设置列表
				//教练设置表
				trainCoachList: [],
				//费用设置
				trainCostList: [
					{
						role: '注册会员',
						roleId: '1',
						cost: ''
					},
					{
						role: '初始会员',
						roleId: '2',
						cost: ''
					},
					{
						role: '荣誉会员',
						roleId: '3',
						cost: ''
					}
				],
				//退款设置
				trainRefundList: []
			},
			visible: false,
			rules: {
				// verifyReason: [
				//     {required: true, message: '审核意见不能为空!', trigger: 'blur' },
				//     {max: 200, message: '审核意见长度不能超过200个字符!'}
				// ]
			}
		}
	},
	methods: {
		zfsuccess (data) {
			this.visibleFee = false
			console.log(data, 789)
			if (data == 1) {
				// this.$showLoading()
				this.$http({
					url: this.$http.adornUrl(
						`/frFranchiseFeeRecord/checkPayStatus`
					),
					method: 'post',
					data: {
						busId: this.ruleForm.id,
						busType: 2,
						busCategory: Number(this.ruleForm.type) + 2
					}
				}).then((data) => {
					if (data && data.code === 0) {
						this.visible = false
						//缴费成功，直接发布
						this.updateState(3)
					} else {
						this.$message.error(data.msg)
					}
				})
			}
		},
		// type 1:查看 2:审核发布
		// pxtype 培训类型
		init (id, type, pxtype) {
			this.pxtype = pxtype
			console.log(id, type)
			this.type = type
			this.title = { 1: '查看详情', 2: '审核发布' }[type]
			this.ruleForm.id = id || null
			this.visible = true
			this.trainCourseList = []
			this.trainCoachList = []
			this.trainRefundList = []
			this.ruleForm.verifyReason = ''
			//回选
			if (this.ruleForm.id) {
				this.$http({
					url: this.$http.adornUrl(
						`/pxTrain/getId/` + this.ruleForm.id
					),
					method: 'get'
				}).then((data) => {
					if (data && data.code === 0) {
						if (data.bean.recommend) {
							data.bean.recommend =
								data.bean.recommend * 1
						}
						this.ruleForm = data.bean
						if (data.bean.roleLimit.length > 0) {
							let roles = data.bean.roleLimit.split(
								','
							)
							let str = ''
							roles.forEach((e) => {
								str += this.roleType[e] + ' '
							})
							this.ruleForm.roleLimit = str
						} else {
							this.ruleForm.roleLimit = '不限角色'
						}

						console.log(data.bean)
						if (data.bean.tablePicUrl) {
							this.listImageUrl =
								data.bean.tablePicUrl
						}
						if (data.bean.detailPicUrl) {
							this.detailImageUrl =
								data.bean.detailPicUrl
						}
						this.ruleForm.applyStrTime =
							data.bean.applyStrTime
						this.ruleForm.applyEndTime =
							data.bean.applyEndTime
						this.ruleForm.trainAbstract =
							data.bean.trainAbstract

						this.$forceUpdate()
						if (type === 2) {
							this.finachiseFeePay()
						}
					}
				})
			}
		},
		releaseSubmit (type) {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					if (type === 3) {
						this.$confirm('是否发布培训?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
							.then(async () => {
								//查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
								//status状态(0未缴费，1已缴费，2已退费)
								if (
									this.record.type === 1 &&
									this.record.status === 0
								) {
									//仅未支付预缴费时，展示二维码支付页面
									this.visibleFee = true
								} else {
									//不是预缴费，则直接发布
									this.updateState(type)
								}
								// this.updateState(type)
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消发布'
								})
							})
					} else if (type === 2) {
						this.updateState(type)
					}
				}
			})
		},
		//查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
		finachiseFeePay () {
			this.$http({
				url: this.$http.adornUrl(
					`/frFranchiseFeeRecord/createQrCode`
				),
				method: 'post',
				data: {
					busId: this.ruleForm.id,
					busType: 2,
					busCategory: Number(this.ruleForm.type) + 2
				}
			}).then((data) => {
				if (data && data.code === 0) {
					this.record = data.record
					console.log('record', this.record)
				} else {
					this.$message.error(data.msg)
				}
			})
		},
		updateState (type) {
			this.$http({
				url: this.$http.adornUrl(`/pxTrain/reviewRelease`),
				method: 'post',
				data: {
					type: type,
					id: this.ruleForm.id,
					content: this.ruleForm.verifyReason
				}
			}).then((data) => {
				if (data && data.code === 0) {
					this.$message({
						message:
							'审核成功' +
							{ 3: '已发布！', 2: '已拒绝！' }[
								type
							],
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.visible = false
							this.$emit('refreshDataList')
						}
					})
				} else {
					this.$message.error(data.msg)
				}
			})
		}
	}
}
</script>
<style>
.el-table__header {
	width: 100% !important;
}
.el-table__body {
	width: 100% !important;
}
</style>
